module.exports = __webpack_public_path__ + "static/img/hippoPic.53e255b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Career/hippoPic.png
// module id = kY0Y
// module chunks = 0